import type { LinkType } from "@/components/loan-application/loan-application-form/LinkType";
import { getApplicationFormNavigationLinks } from "@/helpers/editorSidebarLinks";
import type { FormKitNode } from "@formkit/core";
import type { Ref } from "vue";
import { onMounted, ref } from "vue";

export const useEditorSidebarLinks = (node: Ref<FormKitNode | null>) => {
	const links = ref<LinkType[]>([]);

	onMounted(() => {
		links.value = getApplicationFormNavigationLinks(node.value);
		node.value?.on("commit", () => {
			links.value = getApplicationFormNavigationLinks(node.value);
		});
	});

	return { links };
};
